module.exports = "/assets/6xroM51WGW.png";